module.exports = __webpack_public_path__ + "img/email.a759f08d.png";